import React, { useContext, useEffect, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { Role } from '../../../models';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';

export function RoleDetailsForm(props: { role?: Role; onSaved?: () => void }) {
  const { user } = useContext(UserContext);

  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'roles.edit'));
  }, [user]);

  const onEditFinish = (values: any) => {
    setLoading(true);
    apiClient
      .put(`roles/${props.role?.id}`, values)
      .then(() => {
        setLoading(false);
        if (props.onSaved) {
          props.onSaved();
        }
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  return (
    <Form layout="vertical" onFinish={onEditFinish} initialValues={props.role}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          {
            pattern: /^[a-zA-Z09ıİğĞüÜşŞöÖçÇ][a-zA-Z0-9_\-ıİğĞüÜşŞöÖçÇ\s]*$/,
            message: 'Sadece harf, rakam, boşluk, - ve _ karakteri kullanılabilir',
          },
          { max: 100, message: 'En fazla 100 karakter' },
        ]}
      >
        <Input disabled={!canEdit} />
      </Form.Item>
      <Form.Item
        label="Açıklama"
        name="description"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 400, message: 'En fazla 400 karakter' },
        ]}
      >
        <Input.TextArea disabled={!canEdit} />
      </Form.Item>
      {canEdit && (
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Kaydet
          </Button>
        </Form.Item>
      )}
    </Form>
  );
}
